import React from "react";
import Icon from "components/AppIcon";

export default function SearchBar({ value, onChange, resultCount }) {
  return (
    <div className="relative w-full">
      <div className="absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none">
        <Icon name="Search" size={16} color="var(--color-muted-foreground)" />
      </div>
      <input
        type="search"
        value={value}
        onChange={(e) => onChange(e?.target?.value)}
        placeholder="Search courses by title, topic, or instructor..."
        className="w-full pl-9 pr-10 py-2.5 text-sm bg-[var(--color-card)] border border-[var(--color-border)] rounded-xl text-[var(--color-foreground)] placeholder:text-[var(--color-muted-foreground)] focus:outline-none focus:ring-2 focus:ring-[var(--color-ring)] focus:border-transparent transition-all"
        aria-label="Search training courses"
      />
      {value && (
        <button
          onClick={() => onChange("")}
          className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center rounded-full hover:bg-[var(--color-muted)] transition-colors"
          aria-label="Clear search"
        >
          <Icon name="X" size={12} color="var(--color-muted-foreground)" />
        </button>
      )}
    </div>
  );
}